import { isEmpty } from '../utils/validations';

export class BusinessData {
    public completed: boolean;
    public skipped: boolean;
    public legalPersonality: 'persona física' | 'persona moral';
    public rfc: string;
    public validRfc: boolean;
    public businessName: string;
    public commercialName: string;
    public commercialActivityId: number;
    public societyId: number;

    constructor(object?: any ) {
        object = object ? object : {};
        this.completed = isEmpty(object.completed) ? false : object.completed;
        this.skipped = isEmpty(object.skipped) ? false : object.skipped;
        this.legalPersonality = isEmpty(object.legalPersonality) ? 'persona física' : object.legalPersonality;
        this.rfc = isEmpty(object.rfc) ? null : object.rfc;
        this.validRfc = isEmpty(object.validRfc) ? null : object.validRfc;
        this.businessName = isEmpty(object.businessName) ? null : object.businessName;
        this.commercialName = isEmpty(object.commercialName) ? null : object.commercialName;
        this.commercialActivityId = isEmpty(object.commercialActivityId) ? null : object.commercialActivityId;
        this.societyId = isEmpty(object.societyId) ? null : object.societyId;
    }

    get isMoralPerson(): boolean {
        return this.legalPersonality === 'persona moral';
    }
}
